define('fukit/service/app.tasklist.service',['require','exports','module','../view/app.tasklist.view','../config','backbone.radio'],function(require, exports, module) {
  //prettier-ignore
  var AppTaskListView = require('../view/app.tasklist.view'),
      config          = require('../config'),
      Radio           = require('backbone.radio');

  var AppTaskListService = {
    radioEvents: {
      'app start': 'onAppStart',
      'app ready': 'onAppReady',
    },

    // Defining the constructor class for the task list view in this manner allows us to replace it with
    // a custom view if a product decides it has need for a different view in the task list sidebar.
    AppTaskListViewConstructror: AppTaskListView,

    onAppStart: function() {
      if (!config.get('show.task.list')) {
        return;
      }

      this.appTaskListView = new this.AppTaskListViewConstructror();

      return this.appTaskListView;
    },

    onAppReady: function() {
      var layout;

      if (!config.get('show.task.list')) {
        return;
      }

      layout = Radio.channel('layoutConfiguration').request('layout');
      layout.showChildView('tasklist', this.appTaskListView);

      return layout;
    },
  };

  module.exports = AppTaskListService;
});

